const campaignsDevelopment = [
  {
    id: 5,
    user_id: 5,
    name: "کمپین بنری روپلاک کاسپین ۱۴۰۱",
    category: "گروه بنری روپلاک کاسپین ۱۴۰۱",
    status: 1,
    count_position: "5",
    count_day: "13",
    price_on_day: "57823",
    price_each_hour: "2409",
    price: "346938",
    pledge: "115646",
    price_total: "462584",
    start_date: "1401/08/13 00:00",
    end_date: "1401/08/25 23:59",
    created_at: "1401/08/04 10:06:51",
    type: "بنری",
  },
  {
    id: 4,
    user_id: 5,
    name: "کمپین بنری روز مرد ۱۴۰۰",
    category: "گروه بنری روز مرد ۱۴۰۰",
    status: 3,
    count_position: "11",
    count_day: "4",
    price_on_day: "287500",
    price_each_hour: "11979",
    price: "1150000",
    pledge: "383333",
    price_total: "1533333",
    start_date: "1400/11/25 00:00",
    end_date: "1400/11/28 23:59",
    created_at: "1400/11/23 10:06:51",
    type: "بنری",
  },
  {
    id: 3,
    user_id: 4,
    name: "کمپین بنری روز زن ۱۴۰۰",
    category: "گروه بنری روز زن ۱۴۰۰",
    status: 3,
    count_position: "11",
    count_day: "3",
    price_on_day: "310831",
    price_each_hour: "12951",
    price: "932493",
    pledge: "310831",
    price_total: "1243324",
    start_date: "1400/11/02 00:00",
    end_date: "1400/11/04 23:59",
    created_at: "1400/10/30 15:36:28",
    type: "بنری",
  },
  {
    id: 2,
    user_id: 4,
    name: "کمپین بنری عید فطر ۱۴۰۰",
    category: "گروه بنری عید فطر ۱۴۰۰",
    status: 3,
    count_position: "6",
    count_day: "5",
    price_on_day: "86000",
    price_each_hour: "3583",
    price: "430000",
    pledge: "143333",
    price_total: "573333",
    start_date: "1400/02/22 00:00",
    end_date: "1400/02/26 23:59",
    created_at: "1400/06/20 20:50:00",
    type: "بنری",
  },
  {
    id: 1,
    user_id: 4,
    name: "کمپین بنری عید نوروز ۱۴۰۰",
    category: "گروه بنری عید نوروز ۱۴۰۰",
    status: 3,
    count_position: "13",
    count_day: "22",
    price_on_day: "334165",
    price_each_hour: "13923",
    price: "7351630",
    pledge: "2450543",
    price_total: "9802173",
    start_date: "1399/12/29 00:00",
    end_date: "1400/01/20 23:59",
    created_at: "1399/12/27 10:50:25",
    type: "بنری",
  },
];

const campaignsProduction = [
  {
    id: 5,
    user_id: 5,
    name: "کمپین بنری  روپلاک کاسپین ۱۴۰۱",
    category: "گروه بنری  روپلاک کاسپین ۱۴۰۱  ",
    status: 1,
    count_position: "17",
    count_day: "6",
    price_on_day: "755000",
    price_each_hour: "31458",
    price: "4530000",
    pledge: "1510000",
    price_total: "6040000",
    start_date: "1401/08/05 00:00",
    end_date: "1401/08/10 23:59",
    created_at: "1401/08/04 10:06:51",
    type: "بنری",
  },
  {
    id: 4,
    user_id: 5,
    name: "کمپین بنری روز مرد ۱۴۰۰",
    category: "گروه بنری روز مرد ۱۴۰۰",
    status: 3,
    count_position: "14",
    count_day: "4",
    price_on_day: "45500",
    price_each_hour: "1895",
    price: "182000",
    pledge: "60666",
    price_total: "242666",
    start_date: "1400/11/25 00:00",
    end_date: "1400/11/28 23:59",
    created_at: "1400/11/23 10:06:51",
    type: "بنری",
  },
  {
    id: 3,
    user_id: 4,
    name: "کمپین بنری روز زن ۱۴۰۰",
    category: "گروه بنری روز زن ۱۴۰۰",
    status: 3,
    count_position: "18",
    count_day: "3",
    price_on_day: "67500",
    price_each_hour: "2812",
    price: "202500",
    pledge: "67500",
    price_total: "270000",
    start_date: "1400/11/02 00:00",
    end_date: "1400/11/04 23:59",
    created_at: "1400/10/30 15:36:28",
    type: "بنری",
  },
  {
    id: 2,
    user_id: 4,
    name: "کمپین بنری عید فطر ۱۴۰۰",
    category: "گروه بنری عید فطر ۱۴۰۰",
    status: 3,
    count_position: "16",
    count_day: "5",
    price_on_day: "40500",
    price_each_hour: "1687",
    price: "202500",
    pledge: "67500",
    price_total: "270000",
    start_date: "1400/02/22 00:00",
    end_date: "1400/02/26 23:59",
    created_at: "1400/06/20 20:50:00",
    type: "بنری",
  },
  {
    id: 1,
    user_id: 4,
    name: "کمپین بنری عید نوروز ۱۴۰۰",
    category: "گروه بنری عید نوروز ۱۴۰۰",
    status: 3,
    count_position: "13",
    count_day: "22",
    price_on_day: "594500",
    price_each_hour: "24770",
    price: "13079000",
    pledge: "4359666",
    price_total: "17438666",
    start_date: "1399/12/29 00:00",
    end_date: "1400/01/20 23:59",
    created_at: "1399/12/27 10:50:25",
    type: "بنری",
  },
];

const getCampaigns = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return campaignsProduction;
  }
  return campaignsDevelopment;
};

export default getCampaigns();
